import React, { useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import styles from './index.module.scss';
import cName from "classnames";
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const router = useRouter()
  const t = useTranslations();

  const list = useMemo(() => [
    {
      id: 1,
      title: t('association.item1.title'),
      text: t('association.item1.text'),
      cover: "/image/association/image1.png",
      link: t('association.item1.link'),
    },
    {
      id: 2,
      title: t('association.item2.title'),
      text: t('association.item2.text'),
      cover: "/image/association/image2.png",
      link: t('association.item2.link'),
    },
    {
      id: 3,
      title: t('association.item3.title'),
      text: t('association.item3.text'),
      cover: "/image/association/image4.png",
      link: t('association.item3.link'),
    },
    {
      id: 4,
      title: t('association.item4.title'),
      text: t('association.item4.text'),
      cover: "/image/association/image3.png",
      link: t('association.item4.link'),
    },
  ], [router.locale])

  return (
    <PageLayout temp='page_crumb'>
      <div className={cName(styles.container, router.locale === 'en' && styles.en)}>
        {getHead(navDetail)}
        <div className={cName(styles.content, 'm-1480')}>
          <ul className={styles.list}>
            {list.map((item, index) => (
              <li className={styles.item} key={index}>
                <img className={styles.cover} src={item.cover} alt={item.title} />
                <div className={styles.info}>
                  <p className={styles.title}>{item.title}</p>
                  <p className={styles.text}>{item.text}</p>
                  <a className={styles.link} href={item.link} target="_blank">{t('association.more')}</a>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <style jsx global>
          {
            `
                
            `
          }
        </style>
      </div>
    </PageLayout>
  );
};